import { computed } from "vue";
import { useBuiltComponentSet } from "../../component-built/composables/useBuiltComponentSet";
export const useComponentVariableImpactSummary = (impactedComponentIds) => {
    const { builtComponentSet: impactedComponents } = useBuiltComponentSet(impactedComponentIds);
    const componentVariableImpactSummary = computed(() => {
        const campaignIds = new Set();
        const nonRootComponentIds = new Set();
        impactedComponents.value.forEach((component) => {
            if (!component) {
                return;
            }
            campaignIds.add(component.campaign_id);
            if (!component.isRoot()) {
                nonRootComponentIds.add(component.id);
            }
        });
        const impactedCampaignDescription = (() => {
            if (campaignIds.size === 0) {
                return "";
            }
            if (campaignIds.size === 1) {
                return "1 Campaign, ";
            }
            return `${campaignIds.size} Campaigns, `;
        })();
        const impactedCreativeDescription = (() => {
            if (nonRootComponentIds.size === 0) {
                return "";
            }
            if (nonRootComponentIds.size === 1) {
                return "1 Creative";
            }
            return `${nonRootComponentIds.size} Creatives`;
        })();
        const description = `${impactedCampaignDescription}${impactedCreativeDescription}`;
        return {
            campaignIds,
            nonRootComponentIds,
            description,
        };
    });
    return {
        componentVariableImpactSummary,
    };
};
